import type {
  IDashboardCardVariantData,
  IDashboardColorData,
} from "@components/molecules/dashboardCard/types";
import { Icon } from "@components/atoms/icons";

export const dashboardCardVariants: IDashboardCardVariantData = {
  patients_count: {
    color: "purple",
    icon: (
      <Icon
        name={"UsersGroupTwoRounded"}
        color={"white"}
        type={"bold"}
        fontSize={"xl"}
      />
    ),
  },
  staffs_count: {
    color: "red",
    icon: (
      <Icon
        name={"UsersGroupTwoRounded"}
        color={"white"}
        type={"bold"}
        fontSize={"xl"}
      />
    ),
  },
  pending_summary_note_count: {
    color: "yellow",
    icon: (
      <Icon
        name={"DangerTriangle"}
        color={"white"}
        type={"bold"}
        fontSize={"xl"}
      />
    ),
  },
  local_admins_count: {
    color: "dark",
    icon: (
      <Icon
        name={"UsersGroupTwoRounded"}
        color={"white"}
        type={"bold"}
        fontSize={"xl"}
      />
    ),
  },
  doctors_count: {
    color: "blue",
    icon: (
      <Icon
        name={"UsersGroupTwoRounded"}
        color={"white"}
        type={"bold"}
        fontSize={"xl"}
      />
    ),
  },
  assigned_pending_staff_count: {
    color: "orange",
    icon: (
      <Icon
        name={"CloseSquare"}
        color={"white"}
        type={"bold"}
        fontSize={"xl"}
      />
    ),
  },
  admins_count: {
    color: "light_blue",
    icon: (
      <Icon
        name={"UsersGroupTwoRounded"}
        color={"white"}
        type={"bold"}
        fontSize={"xl"}
      />
    ),
  },
};

export const dashboardColors: IDashboardColorData = {
  red: "#CC2936",
  purple: "#AB29CC",
  yellow: "#FEC101",
  dark: "#564766",
  blue: "#0C6291",
  orange: "#F74B4A",
  light_blue: "#3AA3B0",
};
